import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ba from './locales/ba.json'
import de from './locales/de.json'
import en from './locales/en.json'
import sr from './locales/rs.json'

export enum Language {
  RS = 'rs',
  BA = 'ba',
  EN = 'en',
  DE = 'de',
}

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
export const resources = {
  [Language.EN]: en,
  [Language.RS]: sr,
  [Language.BA]: ba,
  [Language.DE]: de,
}

export const LANGUAGE_KEY = 'user-language'

const setI18nConfig = () => {
  // SSR-safe localStorage access
  const savedLanguage =
    typeof window !== 'undefined' ? localStorage.getItem(LANGUAGE_KEY) : null

  i18n.use(initReactI18next).init({
    resources,
    lng: savedLanguage || Language.BA,
    fallbackLng: Language.EN,
    interpolation: {
      escapeValue: false,
    },
  })
}

// Call this on app start
setI18nConfig()

// Helper to change language and persist it
export const changeLanguage = async (lng: string) => {
  await i18n.changeLanguage(lng)
  if (typeof window !== 'undefined') {
    localStorage.setItem(LANGUAGE_KEY, lng)
  }
}

export default i18n
